<template>
  <div id="app">
    <top></top>
    <div class="app-content">
      <router-view/>
    </div>
    <foot></foot>
  </div>
</template>

<script>
  import Top from './common/top'
  import Foot from './common/footer'

  export default {
    name: 'key',
    data () {
      return {
      }
    },
    mounted () {
      this.$router.push('/')
    },
    components: {
      Top,
      Foot
    }
  }
</script>

<style>
#app {
  width: 100%;
  height: 100%;
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.app-content {
  width: 100%;
  min-height: calc(100% - 112px);
  background: #fafafa;
}
@media only screen and (max-width: 480px) and (min-width: 200px) {
  .app-content {
    min-height: calc(100% - 50px);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue